export const responsiveBlockScrubHeight = { base: '30px', lg: '40px' }
